module.exports = __webpack_public_path__ + "static/media/Isabel_2.fc50c6f2.jpeg";